export var DividerSizeTokens;
(function (DividerSizeTokens) {
    DividerSizeTokens["SM"] = "SM";
    DividerSizeTokens["MD"] = "MD";
    DividerSizeTokens["LG"] = "LG";
})(DividerSizeTokens || (DividerSizeTokens = {}));
